module.exports = __webpack_public_path__ + "static/media/050.840651ac.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/050.wav
 ** module id = 182
 ** module chunks = 0
 **/